import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { PortadaProductoEspecifico } from "./ComponeneteEstructura/PortadaProducto";
import { DescripcionProducto } from "./ComponeneteEstructura/DescripcionProducto";
import { DiseñoDos } from "./ComponeneteEstructura/Diseño2/DiseñoDosPorducto";
import { Diseño3 } from "./ComponeneteEstructura/Diseño3/Diseño3";
import { DiseñoCuatro } from "./ComponeneteEstructura/Diseño4/DiseñoCuatro";
import { DiseñoCinco } from "./ComponeneteEstructura/Diseño5/DiseñoCinco";
import { Helmet, HelmetProvider } from "react-helmet-async";

export const ProductoEspecificoSelecion = () => {
    const [producto, setProduto] = useState([]);
    const [loading, setLoading] = useState(false);
    const [categoria, setCategoria] = useState([]);
    const [error, setError] = useState(null);
    const { id, id_categoria } =useParams();
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    

  useEffect(() => {
    if (!id || !id_categoria) return;

    const controller = new AbortController();
    let isMounted = true;

    const fetchProductoEspecifico = async () => {
      try {
        const response = await axios.get(
          `${backendURL}/api/productos/public/especifico/${id}`,
          { signal: controller.signal }
        );
        if (isMounted) {
          setProduto(response.data.data);
        }
      } catch (err) {
        if (err.code !== "ERR_CANCELED") {
          console.error("Error al obtener producto:", err);
          setError("Hubo un error al cargar el producto");
        }
      }
    };

    const fetchCategoria = async () => {
      try {
        const response = await axios.get(
          `${backendURL}/api/categoria/public/especifico/${id_categoria}`,
          { signal: controller.signal }
        );
        if (isMounted) {
          setCategoria(response.data.data);
        }
      } catch (err) {
        if (err.code !== "ERR_CANCELED") {
          console.error("Error al obtener categoría:", err);
          setError("Hubo un error al cargar la categoría");
        }
      }
    };

    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      await Promise.all([fetchProductoEspecifico(), fetchCategoria()]);
      if (isMounted) {
        setLoading(false);
      }
    };

    fetchAll();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [id, id_categoria, backendURL]);

      if (loading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <CircularProgress size={80} thickness={6} />
                    </Box>
                </div>
            );
        }

        
const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Hod vending",
        "url": `https://www.hodvending.cl/producto/hod/${id}/${id_categoria} `,
       
        "sameAs": [
          "https://www.facebook.com/profile.php?id=61557919715539",
          "https://www.instagram.com/hodvending",
          "https://www.linkedin.com/company/hod-servicios-logísticos/",
          "https://x.com"
        ]
      },
      {
        "@type": "LocalBusiness",
        "name": "HOD Servicios Logísticos ",
      
        "description": " Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Dirección de su negocio",
          "addressLocality": "Ciudad",
          "addressRegion": "Región",
          "postalCode": "Código Postal",
          "addressCountry": "CL"
        },
        "priceRange": "$$",
        "openingHours": "Mo-Fr 08:00-17:00",
        "url":  `https://www.hodvending.cl/producto/hod/${id}/${id_categoria} `
      },
      {
        "@type": "WebPage",
        "name": "Productos",
        "url":  `https://www.hodvending.cl/producto/hod/${id}/${id_categoria} `,
        "datePublished": "2024-07-01",
        "description": " Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia.",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id":  `https://www.hodvending.cl/producto/hod/${id}/${id_categoria} `
        }
      }
    ]
  };

    return (
        <Box>
            <HelmetProvider>
                  <Helmet>
                   <title>{`Máquinas Vending Jofemar | HOD ${producto.titulo_maquina} ${producto.nombre_maquina}`}</title>
                    <meta
                      name="description"
                      content="Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia. "
                    />
                    <meta
                      name="keywords"
                      content=" vending snacks, máquinas de café automáticas, vending de congelados, dispensadores industriales, Casia Lockers, Coffeemar, Jofemar Vision, Jofemar Casia, Jofemar Taos"
                    />
                    <meta
                      property="og:description"
                      content="Descubre nuestra línea de máquinas expendedoras marca Jofemar para snacks, café, congelados y uso industrial. Tecnología de punta, conectividad y eficiencia."
                    />
                    <meta property="og:type" content="website" />
                    <meta property="og:url"  content={`https://www.hodvending.cl/producto/hod/${id}/${id_categoria}`} />
                    <meta property="og:title" content={`Máquinas Vending Jofemar | HOD ${producto.titulo_maquina} ${producto.nombre_maquina}`} />
                    <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                    <meta name="author" content="HOD Servicios Logísticos " />
                    <meta name="robots" content="index,follow" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                    <meta name="publisher" content="HOD Servicios Logísticos " />
                    <link rel="canonical"  href={`https://www.hodvending.cl/producto/hod/${id}/${id_categoria}`}/>
                    <script type="application/ld+json">
                      {JSON.stringify(schemaData)}
                    </script>
                  </Helmet>
                </HelmetProvider>
 {error && <p style={{ color: "red" }}>{error}</p>}
     {!loading && !error && producto && (
    <>
     {producto.diseño === "5" && (
        <DiseñoCinco producto={producto} categoria={categoria} />
      )}
     {producto.diseño === "4" && (
        <DiseñoCuatro producto={producto} categoria={categoria} />
      )}
      {producto.diseño === "3" && (
        <DiseñoDos producto={producto} categoria={categoria} />
      )}

      {producto.diseño === "2" && (
        <Diseño3 producto={producto} categoria={categoria} />
      )}

      {(producto.diseño === "1" || !producto.diseño) && (
        <>
          <PortadaProductoEspecifico producto={producto} categoria={categoria} />
          <DescripcionProducto producto={producto} categoria={categoria} />
        </>
      )}
    </>
  )}
  </Box>
);
}